// Copyright (c) 2016 Deere & Company

import OpenPipsContainer from '../../pip/open-pips/components';

export default {
    component: OpenPipsContainer,
    name: 'OPEN_PIPS',
    path: 'open-pips'
};



// WEBPACK FOOTER //
// ./src/routes/pips/open-pips.js